import React from "react";

export const Disclaimer = (props) => {
  return (
    <footer id="footer">
      <div className="container">
        <p style={{ textAlign: 'center' }}>
          Bruna M. Palma &copy; TODOS OS DIREITOS RESERVADOS
        </p>
        <p style={{ textAlign: 'center' }}>
          Esse site não faz parte do Google LLC nem do Facebook Inc. e não oferecemos nenhum tipo de serviço oficial do governo. Trabalhamos exclusivamente com serviços jurídicos.
        </p>
        <p style={{ textAlign: 'center' }}>
          Algumas imagens utilizadas neste site foram obtidas de br.freepik.com.
        </p>
      </div>
    </footer>
  );
}